export const JAPAN_CODE = 81;
